import { render, staticRenderFns } from "./ProspectsSettings.vue?vue&type=template&id=e92f7688&scoped=true"
import script from "./ProspectsSettings.vue?vue&type=script&lang=js"
export * from "./ProspectsSettings.vue?vue&type=script&lang=js"
import style0 from "./ProspectsSettings.vue?vue&type=style&index=0&id=e92f7688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92f7688",
  null
  
)

export default component.exports